import { useState, useEffect } from 'react';
import Link from '@/components/Link';
import Container from '@/components/Container';
import Image from '@/components/Image/RemoteImage';
import Form from '@/components/Forms';

export default function CertificationValidationTool() {
  const [license, setLicense] = useState(null);

  useEffect(() => {
    if (license !== null) {
      window.open(`//certificaciones.aibes.org/${license}`);
      setLicense(null);
    }
  }, [license]);
  
  return (
    <div className="py-10 lg:py-20 xl:pt-28 xl:pb-32 bg-gradient-to-tr from-green-100 to-white relative z-10">
      <Container className="space-y-10 lg:space-y-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="lg:col-span-7 space-y-4 lg:space-y-6">
            <h1 className="text-4xl lg:text-5xl xl:text-6xl tracking-tight font-extrabold">
              Validación de certificaciones
            </h1>
            <p className="text-lg leading-relaxed text-gray-500 font-med lg:pr-28">
              La herramienta de validación de certificaciones puede ser utilizada por
              empleadores, clientes y otras partes interesadas para validar la autenticidad
              de las&nbsp;
              <Link className="font-medium text-gray-900" href="/certificaciones">
                certificaciones
              </Link>
              &nbsp;avaladas por la Asociación Iberoamericana de Scrum AIBES.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="rounded-full shadow-outside bg-white lg:col-span-9">
            <Form
              initialValues={{
                license: '',
              }}
              onSubmit={(values, {
                resetForm,
              }) => {
                setLicense(values.license);
                resetForm();
              }}
            >
              {({
                values,
                handleChange,
                handleBlur,
              }) => (
                <div className="flex w-full">
                  <div className="pl-8 pr-6 py-5 hidden md:flex items-center space-x-2 border-r border-gray-200">
                    <svg className="w-5 h-5 text-gray-300" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                    </svg>
                    <div className="font-medium">
                      Número de licencia
                    </div>
                  </div>
                  <div className="flex-1 flex">
                    <input
                      type="text"
                      className="w-full focus:outline-none px-5 text-lg lg:text-2xl font-mono placeholder-gray-300 border-none rounded-l-full md:rounded-none focus:ring-green-500"
                      placeholder="Ej. 21170830"
                      name="license"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.license}
                      required
                    />
                  </div>
                  <div className="relative z-0 px-5 py-5">
                    <button className="w-full rounded-full bg-green-600 hover:bg-green-700 focus:ring-4 focus:ring-green-800 focus:ring-opacity-20 focus:bg-green-700 text-white font-medium text-lg px-6 py-2 leading-6 focus:outline-none" type="submit">
                      <svg className="w-5 h-5 md:hidden" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <div className="hidden md:block">
                        Verificar
                      </div>
                    </button>
                  </div>
                </div>
              )}
            </Form>
          </div>
        </div>
      </Container>
      <div className="hidden absolute md:grid md:grid-cols-12 md:inset-0 z-0 overflow-hidden">
        <div className="col-span-5 col-start-8 flex relative">
          <Image
            className="object-cover"
            src="v1612316006/validar/herramienta-de-validacion_ukkpnu.jpg"
            alt="Validación de certificados"
            layout="fill"
          />
        </div>
      </div>
    </div>
  );
}
